import type { StatisticsReport, Summary, TransactionType } from "../types";
import { api, apiBlob } from "./core";

export const reportsApi = {
  summary: (groupId: string) => api<Summary>("/summary", { groupId }),
  statistics: (
    groupId: string,
    filters: {
      dateFrom?: string;
      dateTo?: string;
      bucket?: "day" | "week" | "month";
      type?: TransactionType | "";
      categoryId?: string;
      userId?: string;
      accountId?: string;
      tagIds?: string[];
      merchant?: string;
      limit?: number;
      compare?: "previous" | "year";
    },
  ) => {
    const params = new URLSearchParams();
    if (filters.dateFrom) params.set("date_from", filters.dateFrom);
    if (filters.dateTo) params.set("date_to", filters.dateTo);
    if (filters.bucket) params.set("bucket", filters.bucket);
    if (filters.type) params.set("type", filters.type);
    if (filters.categoryId) params.set("category_id", filters.categoryId);
    if (filters.userId) params.set("user_id", filters.userId);
    if (filters.accountId) params.set("account_id", filters.accountId);
    filters.tagIds?.forEach((tagId) => params.append("tag_ids", tagId));
    if (filters.merchant) params.set("merchant", filters.merchant);
    if (filters.limit) params.set("limit", String(filters.limit));
    if (filters.compare && filters.compare !== "previous") params.set("compare", filters.compare);
    const query = params.toString();
    return api<StatisticsReport>(`/reports/statistics${query ? `?${query}` : ""}`, { groupId });
  },
  exportRecords: async (
    groupId: string,
    options: {
      format: "csv" | "xls" | "xlsx";
      includeRecords: boolean;
      includeCategories: boolean;
      includeAccounts: boolean;
      includeCurrencies: boolean;
      type?: TransactionType | "";
      categoryId?: string;
      userId?: string;
      accountId?: string;
      dateFrom?: string;
      dateTo?: string;
      search?: string;
    },
  ) => {
    const params = new URLSearchParams();
    params.set("format", options.format);
    params.set("include_records", String(options.includeRecords));
    params.set("include_categories", String(options.includeCategories));
    params.set("include_accounts", String(options.includeAccounts));
    params.set("include_currencies", String(options.includeCurrencies));
    if (options.type) params.set("type", options.type);
    if (options.categoryId) params.set("category_id", options.categoryId);
    if (options.userId) params.set("user_id", options.userId);
    if (options.accountId) params.set("account_id", options.accountId);
    if (options.dateFrom) params.set("date_from", options.dateFrom);
    if (options.dateTo) params.set("date_to", options.dateTo);
    if (options.search) params.set("search", options.search);
    return apiBlob(`/exports/records?${params.toString()}`, { groupId });
  },
};
